/// <amd-module name="Wit/DeliveryPlans/PlansTable/DeletePlanDialog" />

import * as React from "react";
import { Dialog } from "VSSUI/Dialog";
import { TitleSize } from "VSSUI/Header";
import * as Resources from "Wit/DeliveryPlans/Resources";

export interface DeletePlanDialogProps {
    onDelete: () => void;
    onDismiss: () => void;
}

export const DeletePlanDialog: React.FunctionComponent<DeletePlanDialogProps> = props => {
    return (
        <Dialog
            escDismiss
            footerButtonProps={[
                {
                    id: "cancel",
                    text: Resources.CancelButtonText,
                    onClick: () => props.onDismiss()
                },
                {
                    id: "confirm",
                    text: Resources.DeleteButtonText,
                    onClick: () => props.onDelete(),
                    danger: true
                }
            ]}
            lightDismiss
            onDismiss={() => props.onDismiss()}
            titleProps={{ size: TitleSize.Large, text: Resources.DeletePlanDialogHeader }}
        >
            {Resources.DeletePlanDialogMessage}
        </Dialog>
    );
};
